var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.team
        ? [
            _c("table", { staticClass: "table table-sm table-hover mt-0" }, [
              _c("thead", [
                _c("tr", [
                  _c("th"),
                  _vm._v(" "),
                  _c("th", [_vm._v("Курьер")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("дата")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("сумма")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("комментарий")]),
                  _vm._v(" "),
                  _c("th", [
                    _c("label", { staticClass: "mb-0" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        on: { change: _vm.selectIncomes },
                      }),
                      _vm._v("\n            выплатить\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  !_vm.actionDisabled ? _c("th") : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.team, function (u, i) {
                    return (_vm.incomes[u.id] ?? []).length
                      ? [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                attrs: {
                                  rowspan: (_vm.incomes[u.id] ?? []).length + 1,
                                },
                              },
                              [_vm._v(_vm._s(i + 1))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                attrs: {
                                  rowspan: (_vm.incomes[u.id] ?? []).length + 1,
                                },
                              },
                              [
                                _vm._v(
                                  "(" + _vm._s(u.id) + ") " + _vm._s(u.name)
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.incomes[u.id]
                            ? _vm._l(_vm.incomes[u.id], function (inc) {
                                return _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.printDate(
                                          inc.report_date,
                                          "DD.MM.YYYY"
                                        )
                                      ) +
                                        " (" +
                                        _vm._s(inc.id) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(inc.sum.toLocaleString("ru-RU"))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(inc.comment))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedIncomes[inc.id],
                                          expression: "selectedIncomes[inc.id]",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.selectedIncomes[inc.id]
                                        )
                                          ? _vm._i(
                                              _vm.selectedIncomes[inc.id],
                                              null
                                            ) > -1
                                          : _vm.selectedIncomes[inc.id],
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.selectedIncomes[inc.id],
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.selectedIncomes,
                                                  inc.id,
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.selectedIncomes,
                                                  inc.id,
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.selectedIncomes,
                                              inc.id,
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.actionDisabled
                                    ? _c(
                                        "td",
                                        [
                                          _c("LoadingButton", {
                                            attrs: {
                                              title: "игнорировать",
                                              type: "button",
                                              loading:
                                                _vm.ignoreBtnLoading[inc.id],
                                              color:
                                                _vm.$constants.LOADING_COLOR,
                                              onClick: () =>
                                                _vm.ignoreIncome(u.id, inc),
                                              className:
                                                "btn btn-sm btn-outline-info",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              })
                            : _vm._e(),
                        ]
                      : _vm._e()
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            Object.keys(_vm.agentsToPay).length
              ? _c(
                  "div",
                  { staticClass: "text-right mr-2" },
                  [
                    _c("div", { staticClass: "flex justify-content-end" }, [
                      _c(
                        "div",
                        { staticClass: "text-left" },
                        _vm._l(_vm.agentsToPay, function (aSum, id) {
                          return _c("div", { staticClass: "fs-18" }, [
                            _c("label", { staticClass: "mb-0" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedAgents[id],
                                    expression: "selectedAgents[id]",
                                  },
                                ],
                                attrs: { type: "checkbox", disabled: "" },
                                domProps: {
                                  checked: Array.isArray(_vm.selectedAgents[id])
                                    ? _vm._i(_vm.selectedAgents[id], null) > -1
                                    : _vm.selectedAgents[id],
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.selectedAgents[id],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.selectedAgents,
                                            id,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.selectedAgents,
                                            id,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.selectedAgents, id, $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(aSum.sum.toLocaleString("ru-RU"))
                                ),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    +id === _vm.agent.id
                                      ? _vm.agent.name
                                      : _vm.hardSubAgent[_vm.agent.id].name
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.actionDisabled
                      ? _c("LoadingButton", {
                          attrs: {
                            title: "Выплатить",
                            type: "button",
                            loading: _vm.payLoadingBtn,
                            color: _vm.$constants.SUCCESS_COLOR,
                            onClick: () => _vm.makePayment(),
                            className: "mt-1 btn btn-sm btn-outline-success",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }